/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SaveAssociatedCompanyDocumentApprovalResponseViewModel } from "../types/SaveAssociatedCompanyDocumentApprovalResponseViewModel.ts";

export const saveAssociatedCompanyDocumentApprovalResponseViewModelSchema =
  z.object({
    success: z.optional(
      z
        .boolean()
        .describe(
          "Indica se o status geral da documentação da conveniada foi recalculado e persistido.",
        ),
    ),
    studentName: z
      .string()
      .describe("Nome do aluno para a mensagem de sucesso da tela.")
      .nullish(),
  }) as unknown as ToZod<SaveAssociatedCompanyDocumentApprovalResponseViewModel>;
